import { useGetWsEsterni } from '@framework/api-client/api/users/ws-esterni-controller/ws-esterni-controller.ts';
import { type IAsyncService } from '@framework/engine/schema/expressions/repository/async/context/IAsyncService.ts';
import { transformWsEsternoInAsyncService } from '../transformWsEsternoInAsyncService.ts';

export interface IAsyncServicesResult {
  services: IAsyncService[] | undefined;
  isLoading: boolean;
  isError: boolean;
}

export function useAsyncServices(): IAsyncServicesResult {
  const { data, isLoading, isError } = useGetWsEsterni({
    limite: 9000,
    flWidget: true,
  });
  return {
    services: data?.dati?.map(transformWsEsternoInAsyncService),
    isLoading,
    isError,
  };
}
